import React, { useEffect, useRef, useState } from "react";
import { Button, CheckPicker, Checkbox, Row, Col, Loader, Modal } from "rsuite";

import { useDispatch, useSelector } from "react-redux";
import { getCrossSellCustomerList } from "../../queries/apiQueries";
import { numberFormatter } from "../../utils";
import "./index.scss";
import CustomerSummaryTable from "./customerSummaryTable";
import ProductClass from "./productClass";
import L3Table from "./l3Tabke";
import RecommendedItemsTable from "./recommendedItemsTable";

const CrossSell = (props: any) => {
  const allFilters = useSelector(
    (state: any) => state.CommonReducer.allFilters
  );

  var isCleared = false;
  const didClear: any = useRef(false);
  const dispatch = useDispatch<any>();

  const [customerList, setCustomerList] = useState<Array<any>>([]);
  const [selectedCustomerList, setSelectedCustomerList] = useState<any>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedProductList, setSelectedProductList] = useState<any>(null);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [selectedL4, setSelectedL4] = useState<any>(null);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [alert, setAlert] = useState(false);

  const [filtersLoading, setFiltersLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const [customerPricingData, setCustomerPricingData] = useState<any>({});
  const [searchCustName, setSearchCustName] = useState<any>(null);
  const [selectedCustomerData, setSelectedCustomerData] = useState<any>(null);
  const [minYAxisValue, setMinYAxisValue] = useState<any>(0);
  const [maxYAxisValue, setMaxYAxisValue] = useState<any>(0);

  const [pageNumber, setPageNumber] = useState(1);
  const [count, setCount] = useState(0);

  const [filterOptions, updateFilterOptions] = useState<any>({
    l1: new Array<{ l1: string }>(),
    l2: new Array<{ l2: string }>(),
    l3: new Array<{ l3: string }>(),
    l4: new Array<{ l4: string }>(),
    projectType: new Array<{ projectType: string }>(),
    peerGroup: new Array<{ peerGroup: string }>(),
    customer: new Array<{ customer: string }>(),
    district: new Array<{ customer: string }>(),
    purchasedItemID: new Array<{ customer: string }>(),
    recommendedItemID: new Array<{ customer: string }>(),
    priority: new Array<{ customer: string }>(),
  });

  const [selectedFilters, setSelectedFilters] = useState<any>({
    ...allFilters,
  });

  const [extraFilters, setExtraFilters] = useState<any>({
    custSize: new Array<{ custSize: string }>(),
    customerSubMarket: new Array<{ customerSubMarket: string }>(),
    custMarket: new Array<{ custMarket: string }>(),
    district: new Array<{ district: string }>(),
    projectFlag: new Array<{ projectFlag: string }>(),
    salesOffice: new Array<{ salesOffice: string }>(),
    startification: new Array<{ startification: string }>(),
  });

  const [initialFilterValues, setInitialFilterValues] = useState<any>({
    custSize: new Array<{ custSize: string }>(),
    customerSubMarket: new Array<{ customerSubMarket: string }>(),
    custMarket: new Array<{ custMarket: string }>(),
    district: new Array<{ district: string }>(),
    projectFlag: new Array<{ projectFlag: string }>(),
    salesOffice: new Array<{ salesOffice: string }>(),
    startification: new Array<{ startification: string }>(),
  });

  const token = useSelector((state: any) => state.CommonReducer.token);

  const filtersMount: any = useRef(false);
  const didMount: any = useRef(true);

  const footerStyles = {
    padding: "10px 2px",
    borderTop: "1px solid #e5e5e5",
  };

  /* Updating filter selection state  */
  const handleFilterUpdate = (value: any, filter: string) => {
    if (isCleared) {
      isCleared = false;
      return;
    }
    filtersMount.current = true;
    let x: string = filter;
    setPageNumber(1);
    if (x == "l1") {
      setSelectedFilters({ l1: value, l2: [], l3: [], l4: [] });
    } else if (x == "l2") {
      setSelectedFilters({ ...selectedFilters, l2: value, l3: [], l4: [] });
    } else if (x == "l3") {
      setSelectedFilters({ ...selectedFilters, l3: value, l4: [] });
    } else if (x == "l4") {
      setSelectedFilters({ ...selectedFilters, l4: value });
    }

    // setSelectedFilters({ ...selectedFilters, [x]: value });
    selectedFilters[x] = value;
  };

  const getCustomerList = async () => {
    let payload: any = {
      customer: [],
      peerGroupName: [],
      projectFlag: ["NonProject"],
      pageSize: 10,
      pageNumber: 1,
      order: "desc",
      orderBy: "marginOpportunity",
      isUpSell: false,
      userEmail: localStorage.getItem("user_email"),
    };

    getCrossSellCustomerList(payload)
      .then((res: any) => {
        if (res.data) {
          let newList = JSON.parse(JSON.stringify(res.data.data));

          setCustomerList(newList);
        }
        //   setLoading(false);
      })
      .catch((err) => {
        //   setLoading(false);
        console.log(err);
      });
  };

  const handleAlertClose = () => setAlert(false);

  const handleAlertConfirmClick = () => {
    setAlert(false);
  };

  useEffect(() => {
    if (didMount.current) {
      getCustomerList();
    }
  }, []);

  return (
    <>
      <Modal
        backdrop={true}
        role="alertdialog"
        open={alert}
        onClose={handleAlertClose}
        size="xs"
        className="cross-sell-modal"
      >
        <Modal.Body>
          <div className="text-center w-full mb-[6vh]">Recommended Items</div>
          <div className="flex h-[12%] justify-between w-[90%] mb-[4vh] pl-[2vh]">
            {Object.keys(filterOptions).length > 0 && (
              <div className="flex gap-x-[2vh]" style={{ flexBasis: "80%" }}>
                {[
                  "projectType",
                  "district",
                  "customer",
                  "purchasedItemID",
                  "recommendedItemID",
                  "priority",
                ].map((filterEntity: string, index: number) => {
                  return (
                    <div className="sub-heading-text" key={filterEntity}>
                      <span className="capitalize">{filterEntity}</span>
                      <CheckPicker
                        data={
                          filterOptions[filterEntity]?.length
                            ? filterOptions[filterEntity]
                            : []
                        }
                        placeholder="All"
                        labelKey={
                          filterEntity == "supplier" ? "vendor" : filterEntity
                        }
                        valueKey={
                          filterEntity == "supplier" ? "vendor" : filterEntity
                        }
                        placement={
                          filterEntity == "l4" ? "bottomEnd" : "bottomStart"
                        }
                        value={
                          selectedFilters[filterEntity]
                            ? selectedFilters[filterEntity]
                            : []
                        }
                        //   onClose={() =>
                        //     filtersMount?.current ? handleClose(filterEntity) : ""
                        //   }
                        //   onClean={() => {
                        //     handleClear(filterEntity);
                        //   }}
                        onChange={(value: any) =>
                          handleFilterUpdate(value, filterEntity)
                        }
                        loading={filtersLoading}
                        renderExtraFooter={() => (
                          <div style={footerStyles}>
                            <Checkbox
                              indeterminate={
                                selectedFilters[filterEntity]?.length > 0 &&
                                selectedFilters[filterEntity]?.length <
                                  filterOptions[filterEntity]?.length
                              }
                              checked={
                                selectedFilters[filterEntity]?.length ===
                                filterOptions[filterEntity]?.length
                              }
                              onChange={(value: any) =>
                                handleFilterUpdate("all", filterEntity)
                              }
                            >
                              Check all
                            </Checkbox>
                          </div>
                        )}
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleAlertConfirmClick} className="modal-yes-btn">
            Download
          </Button>
          <Button onClick={handleAlertClose} className="modal-close-btn">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="cross-sell-container w-full px-10">
        <div className="flex justify-between pt-[2vh]">
          <div className="flex h-[12%] justify-between w-[40%]">
            {/* Filters */}
            {Object.keys(filterOptions).length > 0 && (
              <div className="filter-flex" style={{ flexBasis: "100%" }}>
                {["projectType", "peerGroup", "customer"].map(
                  (filterEntity: string, index: number) => {
                    return (
                      <div className="sub-heading-text" key={filterEntity}>
                        <span className="capitalize">{filterEntity}</span>
                        <CheckPicker
                          data={
                            filterOptions[filterEntity]?.length
                              ? filterOptions[filterEntity]
                              : []
                          }
                          placeholder="All"
                          labelKey={
                            filterEntity == "supplier" ? "vendor" : filterEntity
                          }
                          valueKey={
                            filterEntity == "supplier" ? "vendor" : filterEntity
                          }
                          placement={
                            filterEntity == "l4" ? "bottomEnd" : "bottomStart"
                          }
                          value={
                            selectedFilters[filterEntity]
                              ? selectedFilters[filterEntity]
                              : []
                          }
                          //   onClose={() =>
                          //     filtersMount?.current ? handleClose(filterEntity) : ""
                          //   }
                          //   onClean={() => {
                          //     handleClear(filterEntity);
                          //   }}
                          onChange={(value: any) =>
                            handleFilterUpdate(value, filterEntity)
                          }
                          loading={filtersLoading}
                          renderExtraFooter={() => (
                            <div style={footerStyles}>
                              <Checkbox
                                indeterminate={
                                  selectedFilters[filterEntity]?.length > 0 &&
                                  selectedFilters[filterEntity]?.length <
                                    filterOptions[filterEntity]?.length
                                }
                                checked={
                                  selectedFilters[filterEntity]?.length ===
                                  filterOptions[filterEntity]?.length
                                }
                                onChange={(value: any) =>
                                  handleFilterUpdate("all", filterEntity)
                                }
                              >
                                Check all
                              </Checkbox>
                            </div>
                          )}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            )}
          </div>
          {selectedCustomer && (
            <div>
              <div className="flex gap-x-[1vh]">
                <div className="self-center text-[2.5vh]">
                  Customer - {selectedCustomer}
                </div>
                <button
                  className=" bg-green-700 px-2 py-1 rounded-md h-fit self-center"
                  onClick={() => {
                    setAlert(true);
                  }}
                >
                  GoTogether List
                </button>
              </div>
              <div className="flex gap-x-[1vh] items-center mt-[1vh] justify-end">
                <div style={{ background: "#93d502", width:'4vh', height: '1vh' }} className="recommendLegend"></div>
                <div>Current Portfolio</div>
                <div
                  style={{ background: "#e6f5c6", width:'4vh', height: '1vh' }}
                  className="recommendLegend"
                ></div>
                <div>Cross-Sell Opportunity</div>
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="flex w-full"></div>

          <div className="relative top-[0%]  w-[40%] text-center text-[2vh]">
            Customer Summary (520 Customers, $1.60M Margin Opportunity)
          </div>
        </div>
        <div className="chart-flex h-[75%]">
          <div className="suppliers">
            {tableLoading ? (
              <div className="w-full h-full">
                <Loader
                  className="w-full h-full relative"
                  size="md"
                  inverse
                  center
                  content="loading..."
                />{" "}
              </div>
            ) : (
              <>
                <CustomerSummaryTable
                  data={customerList}
                  selectedCustomerList={selectedCustomerList}
                  updateSelectedCustomerList={(data: any) => {
                    setSelectedCustomerList(data);
                  }}
                  selectedItem={selectedItem}
                  updateSelectedItem={(data: any, customer: any) => {
                    setSelectedItem(data);
                    setSelectedCustomer(customer);
                    setSelectedProduct(null);
                    setSelectedL4(null);
                  }}
                  updateSelectedProductList={(data: any) => {
                    setSelectedProductList(data);
                  }}
                />
              </>
            )}
          </div>

          <div
            className={`chart-container`}
            style={{ border: 0, padding: 0, rowGap: "1vh" }}
          >
            <>
              {isLoading && (
                <div className=" w-full h-full border-mainGreen border-[1px]">
                  <Loader
                    className="w-full h-full relative"
                    size="md"
                    inverse
                    center
                    content="loading..."
                  />
                </div>
              )}
              {!isLoading && (
                <>
                  <div className=" w-full h-[30vh] flex gap-x-[1%]">
                    <div className=" w-[49.5%] h-[20vh] border-mainGreen border-[1px]">
                      <div className="flex justify-between items-center h-full px-[1vh] text-center w-full mr-[2vh] overflow-auto py-[1vh]">
                        {selectedItem ? (
                          <ProductClass
                            data={selectedProductList}
                            selectedProduct={selectedProduct}
                            updateSelectedProduct={(data: any) => {
                              setSelectedProduct(data);
                            }}
                            updateSelectedL4={(data: any) => {
                              setSelectedL4(data);
                            }}
                          />
                        ) : (
                          <span>
                            Click on the left Table to get the Detailed view
                          </span>
                        )}
                      </div>
                    </div>

                    <div className=" w-[49.5%] h-[20vh] border-mainGreen border-[1px]">
                      <div className="flex justify-between items-center h-full px-[1vh] text-center w-full mr-[2vh] overflow-auto py-[1vh]">
                        {selectedProduct ? (
                          <L3Table
                            data={selectedProductList}
                            selectedL4={selectedL4}
                            selectedProduct={selectedProduct}
                            updateSelectedL4={(data: any) => {
                              setSelectedL4(data);
                            }}
                          />
                        ) : (
                          <span>
                            Click on above Product Class for detailed view
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className=" w-full h-[65vh] border-mainGreen border-[1px] overflow-auto">
                    <div className="text-[1.7vh] w-full text-center p-[1vh]">
                      Recommended items to be sold to Customer
                      {selectedL4 && (
                        <RecommendedItemsTable data={selectedProductList} />
                      )}
                    </div>
                  </div>
                </>
              )}
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default CrossSell;
